import React, { useEffect, useState, Fragment } from "react";
import { useTranslation } from 'react-i18next';
import { useNavigate } from "react-router-dom";
import { Row, Col, Card, CardBody, Form, FormGroup, Label, Input, Button, CustomInput } from "reactstrap";
import LoadingOverlay from "react-loading-overlay-ts";
import DNALoader from "../../components/Loaders/DnaLoader.js";
import BusinessService from "./Businesses.service.js";
import AuthService from "../Authentication/auth.service.js";
import Alerts from "../../components/Alerts/alerts.js";

const GeneralTab = ({ business_id, onDataUpdate }) => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);
  const sessionID = localStorage.getItem("session-id");

  const initialData = {
    distance_for_free_delivery: '',
    order_amount_for_free_delivery: '',
    default_normal_delivery_rate: '',
    default_express_delivery_rate: '',
  };

  const [data, setData] = useState(initialData);

  useEffect(() => {
    fetchData();
  }, [business_id]);


  const fetchData = async () => {
    setLoading(true);
    try {
      const response = await BusinessService.getGeneralData(sessionID, business_id);
      //iph todo: 47
      //console.log("response.data", response.data)
      setLoading(false);
      if (response.data.status) {
        if (response.data.data.length > 0) {
          setData(response.data.data[0]);
        } else {
          setData(initialData);
        }
      } else {
        if (response.data.message === "Unauthorized") {
          AuthService.logout();
          navigate("/login");
        } else {
          Alerts.swalErrorAlert(t("Something went wrong, Please try again."));
        }
      }
    } catch (error) {
      setLoading(false);
      Alerts.swalErrorAlert(t("Server Error, Please try again later."));
    }
  };

  const handleInputChange = (e) => {
    const { name, value, type, checked } = e.target;
    setData(prevData => ({ ...prevData, [name]: value }));
  };


  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      let response;
      if (data._id) {
        // Update existing settings
        //iph todo: 47
        //console.log("data update", data)
        response = await BusinessService.updateGeneralData(sessionID, business_id, data);
      } else {
        // Add new settings
        //iph todo: 47
        //console.log("data add", data)
        response = await BusinessService.addGeneralData(sessionID, business_id, data);
      }
      setLoading(false);
      if (response.data.status) {
        Alerts.swalSuccessAlert(t("Settings saved successfully"));
        fetchData();
        // Notify parent component about data update
        if (onDataUpdate) {
          onDataUpdate();
        }
      } else {
        //iph todo: 47
        //console.log("response.data.message", response.data.message)
        Alerts.swalErrorAlert(response.data.message || t("Save failed"));
      }
    } catch (error) {
      setLoading(false);
      console.log("error", error)
      Alerts.swalErrorAlert(t("Server Error, Please try again later."));
    }
  };

  return (
    <Card>
      <CardBody>
        <h3>{t("General Details")}</h3>
        <div className="alert alert-info" role="alert">
          <h5 className="alert-heading">{t("Default Shipment Settings")}</h5>
          <p>{t("Configure default delivery rates that will be automatically applied when setting up new shipping zones. These rates ensure consistent pricing across your business.")}</p>
          <hr />
          <p className="mb-0">{t("Make sure to set both Normal and Express delivery rates before configuring specific shipping methods.")}</p>
        </div>
        <LoadingOverlay active={loading} spinner={<DNALoader />}>
          <Form onSubmit={handleSubmit}>

            <Row>
              <Col md="6">
                <FormGroup>
                  <Label for="distance_for_free_delivery">{t('Distance for Free Delivery (KM)')}</Label>
                  <Input type="number" name="distance_for_free_delivery" id="distance_for_free_delivery" value={data.distance_for_free_delivery} onChange={handleInputChange} />
                </FormGroup>
              </Col>
              <Col md="6">
                <FormGroup>
                  <Label for="order_amount_for_free_delivery">{t('Order Amount for Free Delivery (RM)')}</Label>
                  <Input type="number" name="order_amount_for_free_delivery" id="order_amount_for_free_delivery" value={data.order_amount_for_free_delivery} onChange={handleInputChange} />
                </FormGroup>
              </Col>
            </Row>
            <Row>
              <Col md="6">
                <FormGroup>
                  <Label for="default_normal_delivery_rate">{t('Default Normal Delivery Rate (RM)')}</Label>
                  <Input 
                    type="number" 
                    step="0.01"
                    name="default_normal_delivery_rate" 
                    id="default_normal_delivery_rate" 
                    value={data.default_normal_delivery_rate} 
                    onChange={handleInputChange}
                    placeholder={t('Enter default normal delivery rate')}
                  />
                </FormGroup>
              </Col>
              <Col md="6">
                <FormGroup>
                  <Label for="default_express_delivery_rate">{t('Default Express Delivery Rate (RM)')}</Label>
                  <Input 
                    type="number" 
                    step="0.01"
                    name="default_express_delivery_rate" 
                    id="default_express_delivery_rate" 
                    value={data.default_express_delivery_rate} 
                    onChange={handleInputChange}
                    placeholder={t('Enter default express delivery rate')}
                  />
                </FormGroup>
              </Col>
            </Row>
            <Row>
              <Col md="12" className="d-flex justify-content-center pt-3">
                <Button color="success" type="submit">{data._id ? t('Update') : t('Add')}</Button>
              </Col>

            </Row>
          </Form>
        </LoadingOverlay>
      </CardBody>
    </Card>
  );
};

export default GeneralTab;